import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/publish_private.css";
import "@wikicasa-dev/components/style";
import "core-js/modules/es.array.iterator";
import { createApp, defineAsyncComponent } from "vue";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { removeCookie } from "@utils/CookieUtils";
import commonAsyncComponents from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { BaseComplexToggle, BaseAccordionItem, BaseBadge } from "@wikicasa-dev/components";
//@ts-ignore
import { createPinia, mapActions, mapState } from "pinia";
var PUBLISH_ENUM;
(function (PUBLISH_ENUM) {
  PUBLISH_ENUM[PUBLISH_ENUM["PRIVATE"] = 0] = "PRIVATE";
  PUBLISH_ENUM[PUBLISH_ENUM["AGENT"] = 1] = "AGENT";
})(PUBLISH_ENUM || (PUBLISH_ENUM = {}));
var publicValuationCookie;
import { useBaseStore, useModalStore, useEmailConfirmStore, usePublicUserMenuStore, useLoggedUserStore, useHomeTabStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
var publishPrivateApp = createApp({
  name: "PublishPrivate",
  components: Object.assign(Object.assign(Object.assign({
    BaseButton,
    PublicUserMenu,
    BaseComplexToggle,
    BaseAccordionItem,
    BaseBadge
  }, commonAsyncComponents), {
    //@ts-ignore
    "base-bt-modal": defineAsyncComponent(() => import("@vueEntry/BaseBtModal.vue")),
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons),
  setup() {
    var {
      isDesktopMode,
      isSmall,
      isLarge
    } = useBreakpoints();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      redirectTo
    } = useUtilities();
    return {
      isDesktopMode,
      isSmall,
      isLarge,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      redirectTo
    };
  },
  data() {
    return {
      publishType: undefined
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    enumPublishType() {
      return PUBLISH_ENUM;
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name", "lastLoginDate", "email"])), mapState(useEmailConfirmStore, ["passwordToken", "publicUserEmailConfirmSuccess"])), mapState(useModalStore, ["showModal"])), mapState(useHomeTabStore, ["activeTab"])), mapState(useLoggedUserStore, ["isUserLogged"])),
  created() {
    this.initPublicUserMenu();
  },
  mounted() {
    removeCookie("publicValuationCookie");
    removeCookie("publicValuationRequestCookie");
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    goToSellValuation() {
      // TODO: da fare in modo che porti alla nuova sezione del vendi tramite agenzia
      window.location.href = window["_baseURL"] + "/valutazione-immobile/?sale=true";
    },
    loginAndRedirect(url) {
      return __awaiter(this, void 0, void 0, function* () {
        if (this.isUserLogged) this.redirectTo(url);else {
          localStorage.setItem("redirect", url);
          this.setShowModal(Modals.loginModal);
        }
      });
    }
  }, mapActions(useBaseStore, ["initPublicUserMenu"])), mapActions(useEmailConfirmStore, ["setPasswordToken"])), mapActions(useModalStore, ["setShowModal"])), mapActions(useLoggedUserStore, ["checkIfUserIsLogged"]))
});
publishPrivateApp.use(createPinia());
publishPrivateApp.mount("#publish-main");